import { render } from "./paddedContainer.vue?vue&type=template&id=1c862bba&ts=true"
import script from "./paddedContainer.ts?vue&type=script&lang=ts"
export * from "./paddedContainer.ts?vue&type=script&lang=ts"

import "./paddedContainer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__